import { FC, useState } from 'react';
import { CardBody, CardTitle, CardTitleRow, OutlinedCard, SourceChip } from '../CompanyOverview.styles';
import CapIQFundingRoundsCard from './CapIQFundingRoundsCard';
import { FundingRoundsCardProps } from './FundingRoundsCard.props';
import { TabButton, TabRow } from './FundingRoundsCard.styles';
import SacraFundingRoundsCard from './SacraFundingRoundsCard';

type Tab = 'sacra' | 'capiq';

const FundingRoundsCard: FC<FundingRoundsCardProps> = ({ companyId }) => {
  const [activeTab, setActiveTab] = useState<Tab>('sacra');

  return (
    <OutlinedCard variant="outlined">
      <CardBody>
        <CardTitleRow>
          <CardTitle>Fundraising Rounds</CardTitle>
          {activeTab === 'sacra' && <SourceChip label="Sacra" size="small" chipColor="orange" />}
          {activeTab === 'capiq' && <SourceChip label="Capital IQ" size="small" chipColor="blue" />}
        </CardTitleRow>

        <TabRow>
          <TabButton active={activeTab === 'sacra'} onClick={() => setActiveTab('sacra')}>
            Sacra
          </TabButton>
          <TabButton active={activeTab === 'capiq'} onClick={() => setActiveTab('capiq')}>
            Capital IQ
          </TabButton>
        </TabRow>

        {activeTab === 'sacra' && <SacraFundingRoundsCard companyId={companyId} />}
        {activeTab === 'capiq' && <CapIQFundingRoundsCard companyId={companyId} />}
      </CardBody>
    </OutlinedCard>
  );
};

export { FundingRoundsCard };
